import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function OvertimeCSVPreviewGroupingSection() {}

OvertimeCSVPreviewGroupingSection.prototype = new CSVPreviewSection()

OvertimeCSVPreviewGroupingSection.prototype.init = function(firstGroupingLevel, secondGroupingLevel, numOfDataColumns, numOfGroupingRows) {
    CSVPreviewSection.prototype.init.call(this)
    this.firstGroupingLevel = firstGroupingLevel
    this.secondGroupingLevel = secondGroupingLevel
    this.numOfDataColumns = numOfDataColumns
    this.numOfGroupingRows = numOfGroupingRows
    return this
}

OvertimeCSVPreviewGroupingSection.prototype.addRows = function(tBody) {
    const withSecondLvl = this.secondGroupingLevel !== ReportGroupingLevel.NONE
    const groupingLvls = withSecondLvl ? 2 : 1
    const numOfGroupingRows = withSecondLvl ? this.numOfGroupingRows / 2 : this.numOfGroupingRows

    for (let i = 0; i < numOfGroupingRows; i++) {
        const row = this.createRow()
        ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel))

        if (withSecondLvl)
            ReportPreviewUtils.addEmptyCell(row)

        for (let j = 0; j < this.numOfDataColumns; j++)
            this.addTimeValueCell(row)

        this.addRow(tBody, row)

        if (withSecondLvl) {
            const row = this.createRow()
            ReportPreviewUtils.addEmptyCell(row)
            ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel))

            for (let j = 0; j < this.numOfDataColumns; j++)
                this.addTimeValueCell(row)

            this.addRow(tBody, row)
        }
    }

    const emptyRow = this.createRow()
    const totalColumnsNum = this.numOfDataColumns + groupingLvls

    for (let i = 0; i < totalColumnsNum; i++)
        ReportPreviewUtils.addEmptyCell(emptyRow)

    this.addRow(tBody, emptyRow)

    const totalRow = this.createRow()
    this.addCell(totalRow, this.message("report.total"))
    for (let i = 1; i < groupingLvls; i++)
        ReportPreviewUtils.addEmptyCell(totalRow)

    for (let i = 0; i < this.numOfDataColumns; i++)
        this.addValueCell(totalRow, ReportPreviewUtils.getCSVTimeValue())

    this.addRow(tBody, totalRow)
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/overtime/OvertimeCSVPreviewGroupingSection.js